import { createContext } from 'reka-ui'
import { ref, computed, inject } from 'vue'
import type { FieldEntityTarget } from '@gat-ship/types'
import { customFieldsAdminKey } from '@gat-ship/types/injection-keys'
import { getRegisteredTargets } from '../model/define-system-fields'
import { useCustomFieldsAdmin } from './useCustomFieldsAdmin'

export function defineCustomFieldsView() {
  const groupedTargets = computed(() => {
    const groups = new Map<
      string,
      { target: FieldEntityTarget; label: string }[]
    >()
    for (const t of getRegisteredTargets()) {
      const items = groups.get(t.group) ?? []
      items.push({ target: t.target, label: t.label })
      groups.set(t.group, items)
    }
    return [...groups.entries()].map(([group, items]) => ({
      group,
      items
    }))
  })

  const selectedTarget = ref<FieldEntityTarget>(
    getRegisteredTargets()[0]?.target ?? 'Stakeholder.Client'
  )

  const fields =
    inject(customFieldsAdminKey, undefined) ??
    useCustomFieldsAdmin(selectedTarget)

  return {
    selectedTarget,
    groupedTargets,
    ...fields
  }
}

export const [useCustomFieldsView, provideCustomFieldsView] =
  createContext<ReturnType<typeof defineCustomFieldsView>>('CustomFieldsView')
